<template>
  <section
    class="relative flex items-center w-full min-h-screen bg-center bg-cover bg-no-repeat"
    :style="{ backgroundImage: `url(${require('@/assets/inbros-menu.jpg')})` }"
  >
    <!-- Contenido de la sección -->
    <div class="relative z-10 w-full sm:w-2/3 lg:w-1/2 p-6 sm:p-12 sm:ml-16 lg:ml-24 text-white">
      <div class="max-w-xl">
        <h1
          class="text-4xl sm:text-5xl font-[1000] leading-snug sm:leading-tight mb-4"
          style="text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5)"
        >
          {{ $t('hero.title') }}<br />{{ $t('hero.titleContinue1') }}<br />{{ $t('hero.titleContinue2') }}
        </h1>
        <p
          class="text-base sm:text-xl font-semibold text-white leading-relaxed sm:leading-relaxed"
          style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4)"
        >
          {{ $t('hero.subtitle') }}<br />{{ $t('hero.subtitleContinue1') }}<br />
          {{ $t('hero.subtitleContinue2') }}
        </p>
      </div>
      <div class="mt-8 flex flex-col sm:flex-row gap-4">
        <a
          :href="whatsappLink"
          target="_blank"
          rel="noopener noreferrer"
          class="text-center inline-block bg-white text-[#101541] font-semibold py-3 px-8 rounded-lg hover:bg-orange-600 hover:text-white transition-colors duration-300"
        >
          {{ $t('hero.btnContact') }}
        </a>
        <RouterLink
          to="/about"
          class="text-center inline-block bg-[#303880] text-white font-semibold py-3 px-8 rounded-lg hover:bg-[#0C1A91] transition-colors duration-300"
        >
          {{ $t('hero.btnDiscover') }}
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

useI18n()

const primaryPhone = '6441500822' // Add your WhatsApp phone number
const defaultMessage = 'Hola, me gustaría obtener más información sobre seguros.'

const whatsappLink = `https://wa.me/${primaryPhone}?text=${encodeURIComponent(defaultMessage)}`
</script>
